import { ArrowRight } from "lucide-react";

/**
 * "Consult → Plan → Execute → Report" style step ladder. 4 cards typically.
 */
export default function ProcessSteps({ section }) {
  const { eyebrow, heading, paragraphs = [], cards = [], theme = "white" } = section;
  const bgClass = theme === "navy" ? "bg-mist-navy text-white" : theme === "off" ? "bg-mist-off" : "bg-white";
  const headingColor = theme === "navy" ? "text-white" : "text-mist-navy";
  const paraColor = theme === "navy" ? "text-white/70" : "text-mist-ink/75";
  const cardBg = theme === "navy" ? "bg-white/[0.03] border-white/10" : "bg-mist-off border-mist-soft";
  const cardTitle = theme === "navy" ? "text-white" : "text-mist-navy";
  const cardDesc = theme === "navy" ? "text-white/70" : "text-mist-ink/70";

  return (
    <section className={`${bgClass} py-24 lg:py-32`}>
      <div className="container-mist">
        <div className="max-w-2xl text-left">
          {heading && (
            <h2 className={`font-display text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1] tracking-tight ${headingColor}`}>
              {heading}
            </h2>
          )}
          {(eyebrow || heading) && <div className="mt-4 gold-divider" />}
          {paragraphs[0] && <p className={`mt-5 text-[15px] leading-relaxed ${paraColor}`}>{paragraphs[0]}</p>}
        </div>

        <div className={`mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 relative ${cards.length >= 4 ? "lg:grid-cols-4" : "lg:grid-cols-3"}`}>
          {cards.map((c, i) => (
            <div
              key={i}
              data-testid={c.testid || `step-${i}`}
              className={`relative rounded-md p-6 lg:p-7 border ${cardBg}`}
            >
              {c.number && <div className="font-display text-3xl text-mist-gold">{c.number}</div>}
              <div className="mt-3 h-[1px] w-8 bg-mist-gold" />
              {c.title && <h3 className={`mt-4 font-sans font-semibold text-lg tracking-tight ${cardTitle}`}>{c.title}</h3>}
              {c.description && <p className={`mt-2 text-sm ${cardDesc} leading-relaxed`}>{c.description}</p>}
              {i < cards.length - 1 && cards.length >= 4 && (
                <ArrowRight className="hidden lg:block absolute -right-5 top-1/2 -translate-y-1/2 h-5 w-5 text-mist-gold/70" aria-hidden />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
